import type { PropsWithChildren } from 'react';
import { LazyMotion, MotionConfig } from 'motion/react';

const loadDomAnimation = () => import('@/lib/motion-features').then((module) => module.default);

export function MotionProvider({ children }: PropsWithChildren) {
  return (
    <MotionConfig reducedMotion="user">
      <LazyMotion features={loadDomAnimation}>{children}</LazyMotion>
    </MotionConfig>
  );
}
